<template>
  <div @click="$emit('click')">
    <div class="alert font-weight-bold cursor-pointer"
      :class="active ? 'bg-green active' : 'border border-secondary bg-light'">
      <div class="row">
        <div class="col-7 text-left">
          <h5><i class="icon fas fa-user"></i> {{ mecanico.ds_colaborador }}</h5>
        </div>
        <div v-if="mecanicoTrabalhando" class="col-5 text-right text-overflow-ellipsis">
          🟢 {{$t('Trabalhando')}}
        </div>
      </div>
      <div class="row">
        <div class="col-5 text-left">
          <span class="text-sm font-weight-normal"> {{ $t('Matricula') }} </span><br />
          {{ mecanico.nr_matricula }}
        </div>
        <div class="col-7 text-right text-overflow-ellipsis">
          <span class="text-sm font-weight-normal"> {{$t('Função')}} </span><br />
          {{ mecanico.ds_funcao }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mecanico: {},
    active: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    mecanicoTrabalhando(){
      if(this.mecanico.id == null){
        return false
      }

      return true
    }
  },

  methods: {
    abrirModalConfirmar () {
      this.$swal.fire({
        title: this.$t('Confirmar identidade'),
        text: this.$t('Informe os três primeiros dígitos do seu CPF para confirmar sua identidade'),
        input: 'text',
        inputAttributes: {
          max: 3
        },
        showCancelButton: true,
        confirmButtonText: this.$t('Confirmar'),
        cancelButtonText: this.$t('Cancelar'),
        showLoaderOnConfirm: true,
        onOpen: () => {
          this.$swal.getFocusableElements()[0].focus()
        },
        preConfirm: cpf => {
          if (cpf !== this.mecanico.substr_cpf) {
            this.$swal.showValidationMessage('CPF Incorreto')
            return false
          }

          this.$store.commit('colaborador/setMecanicoAtivo', this.mecanico)
          this.$swal.fire({
            title: 'Mecânico selecionado com sucesso',
            timer: 1000,
            icon: 'success'
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      })
    },
    setMecanicoAtivo () {
      this.$bvModal.hide('modal-tecnicos')
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        if (modalId === 'modal-tecnicos') {
          this.abrirModalConfirmar()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .active {
    box-shadow: 0 0 6px #28a745;
  }

  .alert-dismissible {
    padding-right: 1.25rem;
  }
</style>
